const InputField = ({ label, name, type = "text", value, onChange, required = false, error }) => (
    <div className="flex flex-col gap-1">
        <label htmlFor={name} className="block text-sm font-medium text-gray-700">
            {label} {required && <span className="text-red-500">*</span>}
        </label>
        <input
            type={type}
            name={name}
            id={name}
            value={value || ''}
            onChange={onChange}
            className={`block w-full px-3 py-2 border ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'} rounded-md shadow-sm focus:border-blue-500 sm:text-sm transition-colors duration-200`}
        />
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
);

export default InputField;